
import { gql } from '@apollo/client'

/**
 * Get products details by searchTerm.
 */
 export const GET_PRODUCTS_BY_SEARCH_TERM = gql`
 query GET_PRODUCTS_BY_SEARCH_TERM($storeId: String!, $langId: String!, $searchTerm: String!) {
  productViewFindProductsBySearchTerm(storeId: $storeId, langId: $langId, searchTerm: $searchTerm) {
    recordSetStartNumber
    recordSetCount
    recordSetTotal
    recordSetTotalMatches
    facetView {
        name
        value
        extendedData {
            srchattridentifier
        }
        entry {
            count
            label
            value
        }
    }
    catalogEntryView {
        name
        shortDescription
        partNumber
        uniqueID
        thumbnail
        parentCatalogGroupID
        attributes {
            identifier
            uniqueID
            usage
            values {
                value
            }
        }
    }
  }
 }
 `;
